import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { client } from '@/api/wretch-client';
import { settingsQueryKey } from '../query-keys';

const schema = z.object({
  incident: z.boolean(),
  tag: z.string(),
});

export type SettingsDto = z.infer<typeof schema>;

const placeholderData: SettingsDto = { incident: false, tag: '' };

export const settingsQueryOptions = queryOptions({
  queryKey: settingsQueryKey,
  queryFn: async ({ signal }) => {
    const result = await client.options({ signal }).get(settingsQueryKey[0]).json();
    return schema.parse(result);
  },
  refetchInterval: 10_000,
  notifyOnChangeProps: ['data'],
  placeholderData,
});
